import { createRouter, createWebHashHistory, createWebHistory, createMemoryHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import UserStore from '@/service/auth/UserService';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: 'dashboard/campaigns',
                    name: 'campaigns',
                    component: () => import('@/views/pages/Campaigns.vue'),
                    children: [{ path: 'dashboard/campaign/:tag' }]
                },
                {
                    path: 'dashboard/invoices',
                    name: 'invoices',
                    component: () => import('@/views/pages/invoices/Invoices.vue'),
                    children: [{ path: 'dashboard/invoice/:tag' }]
                },
                {
                    path: 'dashboard/campaign/:tag',
                    name: 'campaign',
                    component: () => import('@/views/pages/Campaign.vue')
                },
                {
                    path: 'dashboard/reports',
                    name: 'reports',
                    component: () => import('@/views/pages/Reports.vue')
                },  
                {
                    path: 'dashboard/information',
                    name: 'information',
                    component: () => import('@/views/pages/Information.vue')
                }, 
                {
                    path: 'dashboard/case-study',
                    name: 'caseStudy',
                    component: () => import('@/views/pages/CaseStudy.vue')
                }, 
                {
                    path: 'dashboard/case-study/:tag',
                    name: 'caseStudyDetails',
                    component: () => import('@/views/pages/CaseStudyDetails.vue')
                }, 
                {
                    path: 'dashboard/case-study/category/:tag',
                    name: 'caseStudyByCategory',
                    component: () => import('@/views/pages/CaseStudyByCategory.vue')
                }, 
                {
                    path: 'dashboard/conference/:tag',
                    name: 'conference',
                    component: () => import('@/views/pages/ConferenceDetails.vue')
                }, 
                {
                    path: 'dashboard/newest-campaign/:tag',
                    name: 'newestCampaign',
                    component: () => import('@/views/pages/NewestCampainDetails.vue')
                }, 
                {
                    path: 'dashboard/general-information/:tag',
                    name: 'generalInformation',
                    component: () => import('@/views/pages/generalInformationDetails.vue')
                },
                {
                    path: 'dashboard/creatives',
                    name: 'creativeUpload',
                    component: () => import('@/views/pages/creative-upload/CreativeUploads.vue'), 
                },
                {
                    path: 'dashboard/creatives/:tag',
                    name: 'creativeUploadDetails',
                    component: () => import('@/views/pages/creative-upload/CreativeUploadDetails.vue')
                },
                {
                    path: 'dashboard/offers',
                    name: 'offers',
                    component: () => import('@/views/pages/offers/Offers.vue')
                },
                {
                    path: '/offers/:tag',
                    name: 'OfferDetails',
                    component: () => import('@/views/pages/offers/OfferDetails.vue')
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: () => import('@/views/pages/Profile.vue')
                }
            ]
        },
        {
            path: '/:catchAll(.*)',
            name: 'NotFound',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/Error.vue')
        },
        {
            path: '/auth/login',
            name: 'login',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/sign-up',
            name: 'signUp',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/Signup.vue')
        },
        {
            path: '/auth/forgot-password',
            name: 'forgotPassword',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/auth/reset-password',
            name: 'resetPassword',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/ResetPassword.vue')
        },
        {
            path: '/auth/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/auth/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        },
        {
            path: '/auth/impersonate',
            name: 'impersonate',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/Impersonate.vue')
        },
        {
            path: '/accept-invitation',
            name: 'acceptInvitation',
            meta: { isPublicPage: true },
            component: () => import('@/views/pages/auth/AcceptInvitation.vue')
        }
    ]
});

//set guard
router.beforeEach((to) => {
    if (!UserStore().isLoggedIn && !to.meta.isPublicPage) {
        return {
            path: '/auth/login',
            // save the location we were at to come back later
            query: { returnUrl: to.fullPath }
        };
    }
});

router.afterEach(() => {
    // scroll to top of the page
    window.scrollTo(0, 0);
});

export default router;
